export function Session__SessionTicketType(session, ticketTypeId) {
  const sessionTicketType = session.ticketTypes.find(
    sessionTicketType => sessionTicketType.ticketTypeId === ticketTypeId
  );
  // lets bail because this session is not associated with this ticket type
  return sessionTicketType && sessionTicketType.status === "enabled"
    ? sessionTicketType
    : undefined;
}
